import { FieldTree } from '@angular/forms/signals';

/**
 * Typ-Workaround für FieldTree:
 * In der Basisklasse greifen wir über `keyof T` auf Felder zu und benötigen dafür nur
 * eine kleine, einheitliche API (name/valid/disabled/touched).
 *
 * Die offizielle FieldTree-Typisierung ist (v. a. in generischen Basisklassen) nicht immer
 * gut per `keyof T` indexierbar, obwohl die Laufzeit-Struktur das hergibt.
 *
 * Daher casten wir einmal zentral auf `CustomFieldTree<T>` (eine "narrow view" auf den Tree).
 */
export const castToCustomFieldTree = <U>(tree: FieldTree<U>): CustomFieldTree<U> => {
  return tree as CustomFieldTree<U>;
};

export type CustomFieldTree<T> = {
  [key in keyof T]: () => {
    name: () => string;
    valid: () => boolean;
    disabled: () => boolean;
    touched: () => boolean;
  };
};
